import styled, { css } from 'styled-components';

import { ITheme } from 'shared/presentation/contexts';

export type TVariant = 'error' | 'warning';

type TVariantColorScheme = (theme: ITheme) => {
  iconColor: string;
};

const CONFIRM_VARIANTS: Record<TVariant, TVariantColorScheme> = {
  error: theme => ({
    iconColor: theme.palette.error.main,
  }),
  warning: theme => ({ iconColor: theme.palette.warning.main }),
};

export const Container = styled.div<{ variant: TVariant }>`
  ${({ theme, variant }) => {
    const variantColors = CONFIRM_VARIANTS[variant](theme);

    return css`
      padding: 2rem;
      border-radius: 24px;
      width: 350px;
      background-color: ${theme.palette.neutral[100]};
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 2rem;

      > svg {
        font-size: 56px;
        color: ${variantColors.iconColor};
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 0.5rem;
        text-align: center;

        h2 {
          font-size: ${theme.typography.sizes.title2};
        }

        p {
          font-size: ${theme.typography.sizes.body1};
          color: ${theme.palette.text.light};
        }
      }

      footer {
        display: flex;
        column-gap: 2rem;
        width: 100%;

        button {
          flex: 1;
        }
      }
    `;
  }}
`;
